import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import s from './CompText.css';
import i18n from '../../../i18n';


class CompText extends Component {

  
  disclosures() {
    return (
      <Fragment>
        <div className={s.introCopy}>
          <span   style={{ color: '#5b6770', fontSize: '14px', fontWeight: '600', marginTop: '10px', marginBottom: '10px' }}>{i18n.t('SPDR S&P 500 ETF Trust (SPY)')} </span>
      
          {i18n.t('SPDR')}
        
          <div >{i18n.t('StateStreet')} </div>
          <div>{i18n.t('StateStreetInfo')}</div>
        </div>
        <br/>
        <div className={s.introCopy}>
          <span style={{ color: '#5b6770', fontSize: '14px', fontWeight: '600', marginTop: '10px', marginBottom: '10px' }}>{i18n.t('iShares Russell 2000 ETF (IWM)')} </span>
          {i18n.t('iSharesIWM')}
        </div>
        <br />
        <div className={s.introCopy}>
          <span style={{ color: '#5b6770', fontSize: '14px', fontWeight: '600', marginTop: '10px', marginBottom: '10px' }}>{i18n.t('iShares MSCI EAFE ETF (EFA)')} </span>
          {i18n.t('iSharesEFA')}
      
        </div>
        <br />
        <div className={s.introCopy}>
          <span style={{ color: '#5b6770', fontSize: '14px', fontWeight: '600', marginTop: '10px', marginBottom: '10px' }}>{i18n.t('iShares MSCI Emerging Markets ETF (EEM)')} </span>
          {i18n.t('iSharesEEM')}
        </div>
        <br />
        <div style={{ color: '#5b6770', fontSize: '14px', fontWeight: '600', marginTop: '10px', marginBottom: '10px' }}>
          {i18n.t('iSharesDist')}
        </div>
        <div style={{ color: '#5b6770', fontSize: '14px', fontWeight: '600', marginTop: '10px', marginBottom: '10px' }}>
          {i18n.t('iSharesInfo')}
        </div>
        <br />

      </Fragment>
    );
  }

  

  render() {
    
      return (
        <div>
          <div className='col-md-12' style={{ marginTop: '20px', paddingLeft: '0px', paddingright: '0px' }}>
            {this.disclosures()}
          </div>
        </div>
      );
    }
  
}

function mapStateToProps(state) {
  return {
  };
}

export default connect(mapStateToProps, {
})(CompText);



// WEBPACK FOOTER //
// ./src/components/App/Compliance/CompText.js